export default "__VITE_ASSET__B7S_hHmc__"